/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For Print page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface IPrint {
  printHeading?: string;
  imageUrl?: string;
  textDescription?: string;
  downloadLink?: string;
}
/**
 *
 * Print component
 * @extends Component
 */
export class Print extends Component {
  private readonly printPage: IPrint = {
    printHeading: 'dream career with Barbie ',
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqf',
    textDescription:
      'What do they want to be when they grow up? A doctor, veterinarian, ballerina or singer? Well, they can be anything! All they have to do is believe it to achieve it, like Barbie! Download and print out this activity sheet and have your little ones draw their dream career. It’s the first step towards reaching their goals!',
    downloadLink:
      'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1ZYc',
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <h1 className='print-heading'>{this.printPage.printHeading}</h1>
        </div>
        <div className='col-lg-12 col-md-12'>
          <div className='printContainer'>
            <img
              className='img-responsive'
              src={this.printPage.imageUrl}
              alt={this.printPage.printHeading}
            />
            <p className='print-description'>
              {ReactHtmlParser(this.printPage.textDescription)}
            </p>
            <a href={this.printPage.downloadLink} className='print-download-link' target='_blank'>download
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
